import { useSelector } from "react-redux";
import System from "src/helper/system";
import ProductInventoryPriceRepository from "src/repository/ProductInventoryPriceRepository";

export function useProductInventoryPriceStore() {
    const inventoryList = useSelector((state) => state.entities.model_ProductInventoryPrice.inventory_list)
    const pricing_list = useSelector((state) => state.entities.model_ProductInventoryPrice.pricing_list)
    const { translation: t } = System;

    let data = {
        inventoryList,
        pricing_list
    };

    let fetch = {
        fetch_product_inventory_list: async (params, isFrom = "") => {
            return await new ProductInventoryPriceRepository().getInventory(params, isFrom)
        },
        get_inventory_by_id: (id) => {
            return inventoryList && inventoryList[id] ? inventoryList[id] : { inventoryQty: 0, inventory: 0, totalQuantity: 0 };
        },
        get_inventory_lead_time: (FactoryLeadTime) => {
            let status = ""
            FactoryLeadTime === null ?
                status = t('factoryLeadTimeUnavailable') :
                status = System.daysToWeeksAndDays(FactoryLeadTime)
            return status
        },
        get_inventory_params: (product) => {
            return new ProductInventoryPriceRepository().getInventoryParams(product)
        },
        get_pricing_by_id: (params) => {
            let Id = params.uniqueId ? params.uniqueId : params.ItemNumber;
            return pricing_list[Id]?.pricing ? pricing_list[Id].pricing : []
        },
        get_current_price_by_quantity: (single_product_pricing_list, QuantityToCart, first_tir_price) => {
            return new ProductInventoryPriceRepository().getCurrentPriceByQuantityAndPriceArray(single_product_pricing_list, QuantityToCart, first_tir_price);

        },
        get_exchange_rate: (params) => {
            return new ProductInventoryPriceRepository().getExchangeRate(params)
        },

    };
    let set = {};

    return [data, fetch, set]
}